var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3 9.5C11.3 7.98847 10.5546 6.61513 9.375 5.72843L9.375 4.30269C11.2431 5.34012 12.5 7.27915 12.5 9.5C12.5 12.8137 9.70178 15.5 6.25 15.5C2.79822 15.5 -1.17422e-07 12.8137 -2.62268e-07 9.5C-3.59345e-07 7.27915 1.25687 5.34012 3.125 4.30269L3.125 5.72843C1.94537 6.61513 1.2 7.98847 1.2 9.5C1.2 12.1053 3.41432 14.3 6.25 14.3C9.08568 14.3 11.3 12.1053 11.3 9.5ZM3.5 3.5L5.77639 1.80902L5.77639 8.5L6.77639 8.5L6.77639 1.80902L9.05279 3.5L9.05279 2.3125L6.27639 0.5L3.5 2.3125L3.5 3.5Z",
    fill: "#F5DF4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ec4bcbfd.svg";
export { ForwardRef as ReactComponent };